import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { ORGANISATION_CACHE_KEY } from 'services/queryKeys';
import { Organisation } from 'types';

export const useGetOrganisation = (organisationId: string | number) => {
  const { data = {} as Organisation, ...rest } = useAxiosQuery<Organisation>(
    ORGANISATION_CACHE_KEY(organisationId),
    `/organisations/${organisationId}/`,
    { enabled: !!organisationId }
  );

  return { organisation: data, ...rest };
};
